import { gql } from '@apollo/client';

export const GET_TRANSITIONS = gql`
  query GetTransitions {
    getTransitions {
      id
      name
      videoKey
      videoURL
      type
      isActive
    }
  }
`;

export const GET_TRANSITION = gql`
  query GetTransition($id: String!) {
    getTransition(id: $id) {
      id
      name
      videoKey
      videoURL
      type
      isActive
    }
  }
`;
